import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import type { AuthenticatedUser } from '@/types'

type AuthState = {
  user: AuthenticatedUser | null
  isLoading: boolean
}

const initialState: AuthState = {
  user: null,
  isLoading: true,
}

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setUser: (state, action: PayloadAction<AuthenticatedUser>) => {
      state.user = action.payload
      state.isLoading = false
    },
    clearAuth: (state) => {
      state.user = null
      state.isLoading = false
    },
  },
})

export const { setUser, clearAuth } = authSlice.actions
export default authSlice.reducer
